module.exports = __webpack_public_path__ + "img/wx.a2a56d88.svg";